import { Heading, Text } from "monday-ui-react-core";

const PermissionDenied: React.FC = () => {

    return (<>
        <Text type={Text.types.TEXT2} className="text-red-600 text-3xl text-center">Access Denied</Text>
        {/* <div className="divide-x"></div> */}
        <hr className="w-1/2 text-center mt-4 mx-auto"></hr>
        <Text type={Text.types.TEXT2} className="mt-10 text-xl text-center" >You don't have permission to view this site.</Text>
    </>)
}


export default PermissionDenied;